import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=fa1db7e0&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa1db7e0')) {
      api.createRecord('fa1db7e0', component.options)
    } else {
      api.reload('fa1db7e0', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=fa1db7e0&", function () {
      api.rerender('fa1db7e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-22jpR9RB988h9/JS/offershelp.vue"
export default component.exports